import { render, staticRenderFns } from "./xmlTicimax.vue?vue&type=template&id=234dcb64"
import script from "./xmlTicimax.vue?vue&type=script&lang=js"
export * from "./xmlTicimax.vue?vue&type=script&lang=js"
import style0 from "./xmlTicimax.vue?vue&type=style&index=0&id=234dcb64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports